module.exports = __webpack_public_path__ + "img/knowhow-4.84b2b23.webp";